/* eslint-disable import/prefer-default-export */

export function enrollAtCourse(course) {
  const formData = new FormData();
  const userAuthToken = this.$store.getters.token;

  this.isLoadingEnroll = true;

  fetch(`${process.env.VUE_APP_API}/courses/${course}/enrollments`, {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: `Bearer ${userAuthToken}`,
    },
  })
    .then((res) => {
      if (res.status === 200 || res.status < 300) {
        return res.json();
      }

      throw res;
    })
    .then((response) => {
      if (response.status === true) {
        window.setTimeout(() => {
          window.location.href = '/panel';
        }, 1000);
      }
    })
    .catch((err) => {
      this.isLoadingEnroll = false;

      throw err;
    });
}
